import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { appConfig } from 'config/appConfig';

// todo move styled components to /ui?

const CenteredLayout = styled('div')(
  () => css`
    display: grid;
    min-height: 100vh;
    grid-template-rows: 2rem auto 1rem;
    grid-template-columns: 100%;
    align-items: center;
    justify-content: center;
    padding: 2.5rem;
  `,
);

const Content = styled.div`
  min-width: 14.5625rem;
  max-width: 25rem;
  width: 100%;
  margin: 0 auto;
`;

const TopBarContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const VersionContainer = styled('div')(
  ({ theme }) => css`
    color: ${theme.palette.primary[500]};
    font-size: ${theme.fontSize.xs};
    margin-left: auto;
  `,
);

export const PublicLayout: FC = () => {
  return (
    <CenteredLayout>
      <TopBarContainer>{/*<LanguageSwitch />*/}</TopBarContainer>
      <Content>
        <Outlet />
      </Content>
      <VersionContainer>version: {appConfig.version}</VersionContainer>
    </CenteredLayout>
  );
};
